import { useState } from 'react'
import { Navbar, Nav, Form, Container, Row, Col, Image, Spinner, Alert } from 'react-bootstrap'
import SliderSlick from 'react-slick'
import InputMask from "react-input-mask";
import FloatingWhatsAppButton from './FloatingWhatsAppButton';

import { FaInstagram } from "react-icons/fa";
import { FaFacebookF } from "react-icons/fa";
import { IoMailOpenOutline } from "react-icons/io5";
import { BiPhoneCall } from "react-icons/bi";
import { IoLocationOutline } from "react-icons/io5";

import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

function Provisorio() {

	const [loading, setLoading] = useState(false)
  const [error, setError] = useState(false)
	const [name, setName] = useState('')
  const [email, setEmail] = useState('')
  const [phone, setPhone] = useState('')
	const [city, setCity] = useState('')
	const [message, setMessage] = useState('')
  const [registeredSuccessfully, setRegisteredSuccessfully] = useState(false)

	const settings = {
		arrows: false,
		dots: false,
		infinite: true,
		speed: 500,
		autoplay: true,
		autoplaySpeed: 5000,
		slidesToShow: 1,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 600,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
					autoplaySpeed: 3000,
				}
			}
		]
	}

	const images = [
		{ image: 'images/topo1.jpg', title: 'Essencial Container | Quem Somos', subtitle: 'Somos pioneiros em venda de Containers' },
		{ image: 'images/topo2.jpg', title: 'Essencial Container | Garantia', subtitle: 'Entrega garantida para todo o Brasil' },
		{ image: 'images/topo3.jpg', title: 'Essencial Container | Locação', subtitle: 'Locação? Consulte nossas opções' },
	];

  const handleChange = (fn) => (e) => {
    e.target.style.border = '';
    fn(e);
  }

	const handleSubmit = async (e) => {
		e.preventDefault()

		if (loading) return
		
    	setLoading(true)

		if (!formValidate()) {
		  setLoading(false)
		  return
		}

		setError(false)

		const bodyMessage = `Novo cadastro via site Essencial Container:
      Nome: ${name}
      Whatsapp: ${phone}
      Email: ${email}
      Cidade: ${city}
      Mensagem: ${message}
		`

		if (!await sendMail(bodyMessage)) {
			setError(true);
			console.log('Notification sending failed')
			return;
		}

		await new Promise(resolve => setTimeout(resolve, 3000));

		setName('')
		setEmail('')
		setPhone('')
		setCity('')
		setMessage('')

		setRegisteredSuccessfully(true)
		setLoading(false);
  };

	const formValidate = () => {
    if (!name || name.length < 3) {
      const fieldName = document.getElementById('formName');
      fieldName.focus();
      fieldName.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldName.style.border = '5px solid red';
      return false;
    }

    if (!phone || !phoneValidate(phone)) {
      const fieldPhone = document.getElementById('formWhatsApp');
      fieldPhone.focus();
      fieldPhone.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldPhone.style.border = '5px solid red';
      return false;
    }

    if (!email || !emailValidate(email)) {
      const fieldEmail = document.getElementById('formEmail');
      console.log('fieldEmail', fieldEmail)
      console.log('email', email)
      fieldEmail.focus();
      fieldEmail.scrollIntoView({ behavior: 'smooth', block: 'center' });
      fieldEmail.style.border = '5px solid red';
      return false;
    }    

    return true;
  }

  const phoneValidate = (phone) => {
    return /^\(\d{2}\) \d{5}-\d{4}$/.test(phone)
  }

  const emailValidate = (email) => {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)
  }

  const sendMail = async (data) => {
    const body = createBody(data)
    console.log('body', body)
    // const response = { ok: true }
    const response = await fetch(`${process.env.REACT_APP_API_CONTROLLER}/send-mail`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Website-Id': process.env.REACT_APP_WEBSITE_ID,
        'Authorization': `Bearer ${process.env.REACT_APP_API_MAIL_KEY}`
      },
      body: JSON.stringify(body)
    })

    if (response.ok) {
      return true
    } else {
      setError(true);
      return false
    }
  }

  const createBody = (message) => {
    return {
      'senderName': 'Site Essencial Container',
      'sender': 'contato@nois.dev.br',
      'recipientName': 'Essencial Container',
      'recipient': 'essencial@essencialcontainer.com',
      'title': 'Nova mensagem via site',
      'message': message,
      'lead': {
        'formId': 25,
        'firstName': name,
        'email': email,
        'phone': phone
      }
    }
  }

  return (
    <>
			<Container id="header">
				<Row className='text-center mt-3 mb-3'>
					<Col lg={3}>
						<Image src='images/logo_essencialcontainer.png' alt='' width='100%' />
					</Col>
					<Col lg={2} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
						<a href='https://www.instagram.com/essencial_containers' target='_blank' rel='noreferrer' className='social-icons'>
							<FaInstagram size={24} style={{ margin: '10px' }} />
						</a>
						<a href='https://www.facebook.com/essencialcontainers' target='_blank' rel='noreferrer' className='social-icons'>
							<FaFacebookF size={24} style={{ margin: '10px' }} />
						</a>
					</Col>
					<Col lg={3} style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								gap: '10px'
							}}
						>
							<IoMailOpenOutline size={32} style={{ color: '#bb2829'  }} />
							<div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.2' }}>
								<span>Email</span>
								<span>essencial@essencialcontainer.com</span>									
							</div>
						</div>
					</Col>
					<Col lg={2} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								gap: '10px'
							}}
						>
							<BiPhoneCall size={32} style={{ color: '#bb2829'  }} />
							<div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.2' }}>
								<span>Ligações</span>
								<span>14 3281-5353</span>									
							</div>
						</div>
					</Col>
					<Col lg={2} style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
						<div
							style={{
								display: 'flex',
								alignItems: 'center',
								gap: '10px'
							}}
						>
							<IoLocationOutline size={32} style={{ color: '#bb2829'  }} />
							<div style={{ display: 'flex', flexDirection: 'column', lineHeight: '1.2' }}>
								<span>Localização</span>
								<span>Bauru/SP</span>									
							</div>
						</div>
					</Col>
				</Row>
			</Container>
			<Container id="menu">
				<Row>
					<Col>
						<Navbar expand="lg" style={{ padding: '20px', backgroundColor: '#DDD' }}>
							<Container>
								<Navbar.Toggle aria-controls="basic-navbar-nav" />
								<Navbar.Collapse id="basic-navbar-nav">
									<Nav className="me-auto teko-font" style={{ fontSize: '24px' }}>
										<Nav.Link href="#home">Home</Nav.Link>
										<Nav.Link href="#about">Quem Somos</Nav.Link>
										<Nav.Link href="#products">Produtos</Nav.Link>
										<Nav.Link href="#rental">Locação</Nav.Link>
										<Nav.Link href="#sustainability">Sustentabilidade</Nav.Link>
										<Nav.Link href="#gallery">Galeria</Nav.Link>
										<Nav.Link href="#contact">Contato</Nav.Link>
									</Nav>
									<Nav>
										<Nav.Link href="#contact" className='botao-vermelho'>
											ORÇAMENTOS
										</Nav.Link>
									</Nav>
								</Navbar.Collapse>
							</Container>
						</Navbar>
					</Col>
				</Row>
			</Container>
			<Container id="banner" fluid>
				<SliderSlick {...settings}>
					{images.map((image, i) => (
            <div key={i} className='patrocinadores-item'>
              <div className='slider'>
                <img src={image.image} alt=''/>
                <div className='slider-image'>
                  <div className='texto-destaque-vermelho titulo-slider'>{image.title}</div>
                  <div className='texto-titulo subtitulo-slider'>
                    {image.subtitle}
                  </div>
                  <button className='botao-vermelho botao-slider'>
                    ENTRE EM CONTATO
                  </button>
                </div>
              </div>
            </div>
					))}
				</SliderSlick>
			</Container>
			<Container id="about" className='mt-5 mb-5'>
				<Row>
					<Col lg={6}>
						<div className='texto-destaque-vermelho'>
							Sobre Nossa Empresa
						</div>
						<div className='texto-titulo mt-2 mb-2'>
							Somos referência de qualidade e experiência em vendas de Containers.
						</div>
						<div className='texto-subtitulo mb-2'>
							Temos mais de 15 anos de experiência para garantir um ótimo negócio.
						</div>
						<div style={{ fontSize: '20px' }}>
							Com uma equipe altamente qualificada e experiente, buscamos sempre as melhores práticas e tecnoligias disponíveis para transformar Containers em espaços funcionais, modernos e adaptados para as necessiades de cada cliente.
						</div>
						<Row className='text-center mt-5'>
							<Col lg={6} className='mb-5'>
								<div className='texto-destaque-grande'>
									15+
								</div>
								<div className='texto-subtitulo'>
									Anos de Experiência
								</div>
							</Col>
							<Col lg={6} className='mb-5'>
								<div className='texto-destaque-grande'>
									100Mil+
								</div>
								<div className='texto-subtitulo'>
									Containers Produzidos
								</div>
							</Col>
							<Col lg={12} className='mb-3'>
								<Row>
									<Col xs={3} lg={1} className='mb-3'>
									 <Image src='/images/img-1.jpg' roundedCircle alt='Atendimento exclusivo' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }} />
									</Col>
									<Col xs={9} lg={7} className='mb-3'>
										<div className='texto-subtitulo' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100%' }}>
											Atendimento exclusivo
										</div>
									</Col>
									<Col xs={12} lg={4}>
										<div className='botao-vermelho'>
											ENTRE EM CONTATO
										</div>
									</Col>
								</Row>
							</Col>
						</Row>
					</Col>
					<Col xs={12} lg={6}>
						<Image src='images/topo-nossa-empresa.jpg' alt='Sobre nós' width='100%' />
					</Col>
				</Row>
			</Container>
			<Container id="banner-products" fluid style={{ padding: '50px', backgroundImage: 'url("images/conteiners-modelos.jpg")' }}>
				<Row className='text-center mt-5 mb-5 teko-font' style={{ color: '#FFF' }}>
					<Col lg={12} style={{ fontSize: '80px', fontWeight: 'bold' }}>
						Escolha o seu modelo
					</Col>
					<Col lg={12} style={{ fontSize: '30px' }}>
						Com entrega garantida!
					</Col>
				</Row>
			</Container>
			<Container id="products">
				<Row className='mt-5'>
					<Col lg={12} className='text-center texto-titulo mt-5 mb-5'>
						Com equipe técnica especializada transformamos os containers reefer ou dry para atender diversas aplicações, com baixo custo construtivo e facilidade na movimentação.
					</Col>
					<Col lg={3}>
						<Image src='images/box1.jpg' alt='Produto 1' width='100%' />
						<div className='texto-subtitulo mt-3' style={{ fontWeight: '400' }}>
							DRY 20 PÉS
						</div>
            <div className='texto-subtitulo mt-3' style={{ fontSize: '30px' }}>
              O container de ferro trata-se de um container de aço corten, com assoalho de compensado naval em madeira de 28mm de espessura.
            </div>
            <div className='mt-2'>
              Medidas: <br />
              6 comprimento <br />
              2.44 de largura <br />
              2.60 de altura
            </div>
            <div className='texto-destaque-vermelho'>
              PRONTA ENTREGA!
            </div>
					</Col>
					<Col lg={3}>
						<Image src='images/box2.jpg' alt='Produto 2' width='100%' />
						<div className='texto-subtitulo mt-3' style={{ fontWeight: '400' }}>
							HC 40 PÉS
						</div>
            <div className='texto-subtitulo mt-3' style={{ fontSize: '30px' }}>
              O container de ferro trata-se de um container de aço corten, com assoalho de compensado naval em madeira de 28mm de espessura.
            </div>
            <div className='mt-2'>
              Medidas: <br />
              12.19 comprimento <br />
              2.44 de largura <br />
              2.89 de altura
            </div>
            <div className='texto-destaque-vermelho'>
              PRONTA ENTREGA!
            </div>
					</Col>
					<Col lg={3}>
						<Image src='images/box3.jpg' alt='Produto 3' width='100%' />
						<div className='texto-subtitulo mt-3' style={{ fontWeight: '400' }}>
							DRY 40 PÉS
						</div>
            <div className='texto-subtitulo mt-3' style={{ fontSize: '30px' }}>
              Containers 40 pés HC modificados conforme sua necessidade, seja para depósito, almoxarifado, estoque, lojas, lanchonetes.
            </div>
            <div className='mt-2'>
              Medidas: <br />
              12.19 comprimento <br />
              2.44 de largura <br />
              2.60 de altura
            </div>
            <div className='texto-destaque-vermelho'>
              PRONTA ENTREGA!
            </div>
					</Col>
					<Col lg={3}>
						<Image src='images/box4.jpg' alt='Produto 4' width='100%' />
						<div className='texto-subtitulo mt-3' style={{ fontWeight: '400' }}>
							REEFER 12 Metros
						</div>
            <div className='texto-subtitulo mt-3' style={{ fontSize: '30px' }}>
              O container de ferro trata-se de um container de aço corten, com assoalho de compensado naval em madeira de 28mm de espessura.
            </div>
            <div className='mt-2'>
              Medidas: <br />
              12.19 comprimento <br />
              2.44 de largura <br />
              2.89 de altura
            </div>
            <div className='texto-destaque-vermelho'>
              PRONTA ENTREGA!
            </div>
					</Col>
				</Row>
			</Container>
			<Container fluid id="rental" className='mt-5' style={{ background: '#F5F5F5', backgroundImage: 'url("images/banner-locacao.jpg")' }}>
				<Row>
					<Col>
						<Container className='mt-5 mb-5'>
							<Row>
								<Col lg={12} className='text-center mb-5'>
									<div className='texto-destaque-vermelho'>
										Locação
									</div>
									<div className='texto-titulo'>
										O que é locação de containers?
									</div>
								</Col>
								<Col lg={12}>
									A Essencial containers é especializada em locação de uma grande variedade de containers tornando sua obra mais prática e segura da construção ao administrativo. Estamos no mercado a mais de 15 anos. Nossa empresa tem a reputação de ser uma parceira confiável e comprometida com o atendimento e entrega.<br /><br />
									O processo de locação de container é feito por um determinado período de tempo conforme a necessidade do cliente, o pagamento firmado no contrato de locação, assinado pela locadora e locatária. Se você está interessado em alugar um container nós estamos aqui para tornar seu processo de locação mais rápido e eficiente.
								</Col>
								<Col lg={6} className='mt-5 mb-5'>
									<Image src='images/locacao1.jpg' alt='Locação' width='100%' />
								</Col>
								<Col lg={6} className='mt-5 mb-5'>
									<Image src='images/locacao2.jpg' alt='Locação' width='100%' />
								</Col>
                <Col lg={{ span: 2, offset: 5 }} >
                  <div className='botao-vermelho'>
                    ENTRE EM CONTATO
                  </div>
                </Col>
							</Row>
						</Container>
					</Col>
				</Row>
			</Container>
			<Container id="sustainability" className='mt-5 mb-5'>
				<Row>
					<Col lg={12} className='text-center mb-5'>
						<div className='texto-titulo'>
							Se você precisa de um espaço inovador e sustentável para seu negócio, conte com a Essencial Container!
						</div>
						<div>
							É comprovado que o reúso de containers marítimos contribui significativamente para a preservação do meio ambiente, pois reduz a quantidade de resíduos gerados e diminui a necessidade de construção de novos edifícios.
						</div>
					</Col>
					<Col lg={4}>
						<Image src='images/sustentabilidade.jpg' alt='Sustentabilidade' width='100%' />
					</Col>
					<Col lg={8}>
						<div className='texto-destaque-vermelho'>
							Sustentabilidade
						</div>
						<div className='texto-titulo' style={{ color: '#178162' }}>
							Nós oferecemos soluções inovadoras e sustentáveis para diversos segmentos do mercado.
						</div>
						<div>
							Somos uma das 3 maiores empresas em venda de containers, especializada em projetos de reúso de container marítimo, oferecendo soluções inovadoras e sustentáveis para diversos segmentos do mercado.<br /><br />
							Com uma equipe altamente qualificada e experiente, buscamos sempre as melhores práticas e tecnologias disponíveis para transformar containers em espaços funcionais, modernos e adaptados para as necessidades específicas de cada cliente.<br /><br />
							Além disso, é comprovado que o reúso de containers marítimos contribui significativamente para a preservação do meio ambiente, pois reduz a quantidade de resíduos gerados e diminui a necessidade de construção de novos edifícios.<br /><br />
							Se você precisa de um espaço inovador e sustentável para o seu negócio, conte com a nossa empresa e descubra as infinitas possibilidades oferecidas pelo reúso de container marítimo, seja para venda ou locação para atender a sua obra. Peça já seu orçamento.
						</div>
					</Col>
				</Row>
			</Container>
			<Container id="gallery" fluid className='mt-5 mb-5' style={{ color: '#FFF', background: '#1A284F' }}>
				<Row>
					<Col>
						<Container className='mt-5 mb-5'>
							<Row>
								<Col lg={12}>
									<div className='teko-font' style={{ fontSize: '50px', color: '#FFF' }}>Nossa Galeria</div>
								</Col>
								<Col lg={4} className='mt-4'>
									<Image src='images/galeria2.jpg' alt='Galeria 1' width='100%' />
								</Col>
								<Col lg={4} className='mt-4'>
									<Image src='images/galeria3.jpg' alt='Galeria 2' width='100%' />
								</Col>
								<Col lg={4} className='mt-4' >
									<Image src='images/galeria1.jpg' alt='Galeria 3' width='100%' />
								</Col>
								<Col lg={4} className='mt-4'>
									<Image src='images/galeria4.jpg' alt='Galeria 1' width='100%' />
								</Col>
								<Col lg={4} className='mt-4'>
									<Image src='images/galeria5.jpg' alt='Galeria 2' width='100%' />
								</Col>
								<Col lg={4} className='mt-4'>
									<Image src='images/galeria6.jpg' alt='Galeria 3' width='100%' />
								</Col>
							</Row>
						</Container>
					</Col>
				</Row>
			</Container>
			<Container id="delivery" className='text-center mb-5'>
				<Row>
					<Col lg={12}>
						<div className='texto-titulo'>
							Entregamos o projeto concluído ou com serralheria pronta para que seja finalizada no local.
						</div>
						<div>
							E aí, gostou de conhecer um pouco mais sobre as soluções em construção com contêiner? Com certeza, essa é uma opção inteligente e sustentável para quem busca praticidade e qualidade na hora de construir. Além disso, a construção em contêiner ainda contribui para o meio ambiente, reduzindo a quantidade de resíduos gerados na obra. Então, se você está pensando em construir, já sabe: leve o container até você e comece a desfrutar de todos esses benefícios!
						</div>
					</Col>
          <Col lg={{ span: 2, offset: 5 }} className='mt-4'>
            <div className='botao-vermelho'>
              ENTRE EM CONTATO
            </div>
          </Col>
				</Row>
			</Container>
			<Container id="contact" fluid style={{ backgroundImage: 'url("images/banner-contato.jpg")'}}>
				<Row>
					<Col>
						<Container className='mt-5 mb-5'>
							<Row>
								<Col lg={6} style={{ padding: '20px' }}>
									<div style={{ background: '#FFF' }}>
										<Row style={{ padding: '20px' }}>
											<Col lg={3}>
												<div>
													<BiPhoneCall size={32} style={{ color: '#bb2829'  }} />
												</div>
												<div className='mt-2'>
													WhatsApp
												</div>
												<div className='texto-subtitulo' style={{ fontSize: '26px' }}>
													14 99700-2166
												</div>
												<div className='mt-2'>
													Ligações
												</div>
												<div className='texto-subtitulo' style={{ fontSize: '26px' }}>
													14 3281-5353
												</div>
											</Col>
											<Col lg={5}>
											 <div>
												<IoMailOpenOutline size={32} style={{ color: '#bb2829'  }} />
											 </div>
											 <div className='mt-2'>
												Email
											 </div>
											 <div className='texto-subtitulo' style={{ fontSize: '24px' }}>
												essencial@essencialcontainer.com
											 </div>
											</Col>
											<Col lg={4}>
											<div>
												<IoLocationOutline size={32} style={{ color: '#bb2829'  }} />
											 </div>
											 <div className='mt-2'>
												Localização
											 </div>
											 <div className='texto-subtitulo' style={{ fontSize: '24px' }}>
												Rua Antônio Gobete, 8-22.
											 </div>
											 <div className='texto-subtitulo' style={{ fontSize: '24px' }}>
												Vl. Engler. Bauru/SP/Brasil
											 </div>
											</Col>
										</Row>
										<Row style={{ padding: '10px' }}>
											<Col lg={12}>
												<iframe src="https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d14762.220147949733!2d-49.049442!3d-22.332662!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x94bf6796d25a07b9%3A0x3b6b343257f17f49!2sESSENCIAL%20CONTAINERS%20-%20Aluguel%20e%20venda%20de%20container!5e0!3m2!1spt-BR!2sbr!4v1761612668040!5m2!1spt-BR!2sbr" width="100%" height="200" style={{ border: 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
											</Col>
										</Row>
									</div>
								</Col>
								<Col lg={6} style={{ padding: '20px' }}>
									<div style={{ background: '#FFF' }}>
										<Row style={{ padding: '20px' }}>
											<Col lg={12}>
												<div className='texto-destaque-vermelho'>
													Fale Conosco
												</div>
												<div className='texto-titulo'>
													Solicite um Orçamento
												</div>
											</Col>
											<Col lg={12} className='mt-3 mb-3'>
												<Form>
													<Form.Group className="mb-3">
														<Form.Label>Nome Completo</Form.Label>
														<Form.Control
                              id="formName"
                              type="text"
                              placeholder="Digite seu nome"
                              value={name}
                              onChange={handleChange(e => setName(e.target.value))}
                            />
													</Form.Group>
													<Form.Group className="mb-3">
														<Form.Label>WhatsApp</Form.Label>
														<Form.Control
                              id="formWhatsApp"
                              as={InputMask}
                              mask='(99) 99999-9999'
                              placeholder="(99) 99999-9999"
                              value={phone}
                              onChange={handleChange(e => setPhone(e.target.value))}
                            />
													</Form.Group>
													<Form.Group className="mb-3">
														<Form.Label>E-mail</Form.Label>
														<Form.Control
                              id="formEmail"
                              type="email"
                              placeholder="Digite seu email"
                              value={email}
                              onChange={handleChange(e => setEmail(e.target.value))}
                            />
													</Form.Group>
													<Form.Group className="mb-3">
														<Form.Label>Cidade/UF</Form.Label>
														<Form.Control
                              id="formCity"
                              type="text"
                              placeholder="Digite sua cidade e estado"
                              value={city}
                              onChange={handleChange(e => setCity(e.target.value))}
                            />
													</Form.Group>
													<Form.Group className="mb-3">
														<Form.Label>Mensagem</Form.Label>
														<Form.Control
                              id="formMessage"
                              as="textarea"
                              rows={3}
                              placeholder="Digite sua mensagem"
                              value={message}
                              onChange={handleChange(e => setMessage(e.target.value))}
                            />
													</Form.Group>
													<div className='botao-vermelho' onClick={handleSubmit}>
														{loading ? (
                              <>
                                <Spinner
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                />{" "}
                                ENVIANDO...
                              </>
                            ) : (
                              "ENVIAR"
                            )}
													</div>
                          <Alert variant="success" className='mt-3 text-center' style={{ display: registeredSuccessfully ? 'block' : 'none' }}>
                            <b>Mensagem enviada com sucesso!</b>
                          </Alert>
												</Form>
											</Col>
										</Row>
									</div>
								</Col>
							</Row>
						</Container>
					</Col>
				</Row>
			</Container>
			<Container id="footer" fluid style={{ background: '#192436', color: '#FFF', padding: '20px' }}>
				<Row>
					<Col>
						<Container>
							<Row className='text-center mt-3 mb-3'>
								<Col lg={12}>
									<div>
										Siga-nos
									</div>
								</Col>
								<Col lg={12} className='mt-2 mb-3' style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '10px' }}>
									<a href='https://www.instagram.com/essencial_containers' className='social-icons' target='_blank' rel='noreferrer'>
										<FaInstagram size={24} style={{ margin: '10px' }} />
									</a>
									<a href='https://www.facebook.com/www.essencialcontainer.com.br' className='social-icons' target='_blank' rel='noreferrer'>
										<FaFacebookF size={24} style={{ margin: '10px' }} />
									</a>
								</Col>
								<Col lg={12}>
									© 2025 Essencial Container. Todos os direitos reservados.
								</Col>
							</Row>
						</Container>
					</Col>
				</Row>
			</Container>
			<FloatingWhatsAppButton />
    </>
  );
}

export default Provisorio;